import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2017367258/src/src/app/ui/common/side-menu.tsx");
